import { Box } from '@mui/material';
import BillingForm from './billing/billing.form';
import GeneralForm from './general/general.form';
import InvoiceTable from './invoice/invoice-table';
import { OrganizationPlayoutSettingsPanel } from '@/components/playout/organization-playout-settings-panel';
import { OrganizationConfidencePresetsPanel } from './confidence-presets';
import type { Control } from 'react-hook-form';
import type { EditActiveOrganization } from '../edit.modal';
import type { SetValueFunction, ClearErrorsFunction } from '@/types/form';

export type MenuButtonType = 'general' | 'billing' | 'invoices' | 'playout' | 'confidence';

export default function Tabs({
  type,
  control,
  setValue,
  clearErrors,
  organizationId,
  close,
}: {
  type: MenuButtonType;
  control: Control<EditActiveOrganization>;
  setValue: SetValueFunction<EditActiveOrganization>;
  clearErrors: ClearErrorsFunction<EditActiveOrganization>;
  organizationId?: string;
  close: React.Dispatch<React.SetStateAction<void>>;
}) {
  return (
    <Box>
      {type === 'general' && <GeneralForm close={close} control={control} />}
      {type === 'playout' && organizationId && <OrganizationPlayoutSettingsPanel organizationId={organizationId} />}
      {type === 'confidence' && organizationId && (
        <OrganizationConfidencePresetsPanel organizationId={organizationId} />
      )}
      {type === 'billing' && <BillingForm control={control} setValue={setValue} clearErrors={clearErrors} />}
      {type === 'invoices' && organizationId && <InvoiceTable organizationId={organizationId} />}
    </Box>
  );
}
